import { DateTime } from "luxon";
import { DatePickerOption } from "./types";

export const getCurrentTimeInUTC = () => DateTime.local();

const durationOptions: DatePickerOption[] = [
  {
    displayText: "Today",
    label: "today",
    startDate: getCurrentTimeInUTC(),
    endDate: getCurrentTimeInUTC(),
    value: "today",
    key: "today",
  },
  {
    displayText: "Yesterday",
    label: "yesterday",
    startDate: getCurrentTimeInUTC().minus({ days: 1 }),
    endDate: getCurrentTimeInUTC().minus({ days: 1 }),
    value: "yesterday",
    key: "yesterday",
  },
  {
    displayText: "Last 7 Days",
    label: "last_7_days",
    startDate: getCurrentTimeInUTC().minus({ days: 7 }),
    endDate: getCurrentTimeInUTC(),
    value: "last_7_days",
    key: "last_7_days",
  },
  {
    displayText: "Last 14 Days",
    label: "last_14_days",
    startDate: getCurrentTimeInUTC().minus({ days: 14 }),
    endDate: getCurrentTimeInUTC(),
    value: "last_14_days",
    key: "last_14_days",
  },
  {
    displayText: "Last 30 Days",
    label: "last_30_days",
    startDate: getCurrentTimeInUTC().minus({ days: 30 }),
    endDate: getCurrentTimeInUTC(),
    value: "last_30_days",
    key: "last_30_days",
  },
  {
    displayText: "Last 90 Days",
    label: "last_90_days",
    startDate: getCurrentTimeInUTC().minus({ days: 90 }),
    endDate: getCurrentTimeInUTC(),
    value: "last_90_days",
    key: "last_90_days",
  },
  {
    displayText: "This Week",
    label: "this_week",
    startDate: getCurrentTimeInUTC().startOf("week"),
    endDate: getCurrentTimeInUTC(),
    value: "this_week",
    key: "this_week",
  },
  {
    displayText: "Last Week",
    label: "last_week",
    startDate: getCurrentTimeInUTC().startOf("week").minus({ weeks: 1 }),
    endDate: getCurrentTimeInUTC().startOf("week").minus({ days: 1 }),
    value: "last_week",
    key: "last_week",
  },
  {
    displayText: "This Month",
    label: "this_month",
    startDate: getCurrentTimeInUTC().startOf("month"),
    endDate: getCurrentTimeInUTC(),
    value: "this_month",
    key: "this_month",
  },
  {
    displayText: "Last Month",
    label: "last_month",
    startDate: getCurrentTimeInUTC()
      .startOf("month")
      .minus({ months: 1 })
      .startOf("day"),
    endDate: getCurrentTimeInUTC().startOf("month").minus({ days: 1 }),
    value: "last_month",
    key: "last_month",
  },
  {
    displayText: "This Quarter",
    label: "this_quarter",
    startDate: getCurrentTimeInUTC().startOf("quarter"),
    endDate: getCurrentTimeInUTC(),
    value: "this_quarter",
    key: "this_quarter",
  },
  {
    displayText: "Last Quarter",
    label: "last_quarter",
    startDate: getCurrentTimeInUTC()
      .startOf("quarter")
      .minus({ quarters: 1 })
      .startOf("day"),
    endDate: getCurrentTimeInUTC().startOf("quarter").minus({ days: 1 }),
    value: "last_quarter",
    key: "last_quarter",
  },
  {
    displayText: "This Year",
    label: "this_year",
    startDate: getCurrentTimeInUTC().startOf("year"),
    endDate: getCurrentTimeInUTC(),
    value: "this_year",
    key: "this_year",
  },
  {
    displayText: "Last Year",
    label: "last_year",
    startDate: getCurrentTimeInUTC()
      .startOf("year")
      .minus({ years: 1 })
      .startOf("day"),
    endDate: getCurrentTimeInUTC().startOf("year").minus({ days: 1 }),
    value: "last_year",
    key: "last_year",
  },
  {
    displayText: "Custom",
    label: "custom",
    startDate: getCurrentTimeInUTC().minus({ days: 30 }),
    endDate: getCurrentTimeInUTC(),
    value: "custom",
    key: "custom",
  },
];

export default durationOptions;

export const getDateRange = (displayName, tz) => {
  // To be fixed: Refact to lazy load the date filter

  const now = DateTime.now().setZone(tz);
  const ranges = {
    today: { startDate: now, endDate: now },
    yesterday: {
      startDate: now.minus({ days: 1 }),
      endDate: now.minus({ days: 1 }),
    },
    last_7_days: {
      startDate: now.minus({ days: 7 }),
      endDate: now,
    },
    last_14_days: {
      startDate: now.minus({ days: 14 }),
      endDate: now,
    },
    last_30_days: {
      startDate: now.minus({ days: 30 }),
      endDate: now,
    },
    last_90_days: {
      startDate: now.minus({ days: 90 }),
      endDate: now,
    },
    this_week: { startDate: now.startOf("week"), endDate: now },
    last_week: {
      startDate: now.startOf("week").minus({ weeks: 1 }),
      endDate: now.startOf("week").minus({ days: 1 }),
    },
    this_month: { startDate: now.startOf("month"), endDate: now },
    last_month: {
      startDate: now.startOf("month").minus({ months: 1 }),
      endDate: now.startOf("month").minus({ days: 1 }),
    },
    this_quarter: {
      startDate: now.startOf("quarter"),
      endDate: now,
    },
    last_quarter: {
      startDate: now.startOf("quarter").minus({ quarters: 1 }),
      endDate: now.startOf("quarter").minus({ days: 1 }),
    },
    this_year: { startDate: now.startOf("year"), endDate: now },
    last_year: {
      startDate: now.startOf("year").minus({ years: 1 }),
      endDate: now.startOf("year").minus({ days: 1 }),
    },
  };

  return (
    ranges[displayName] || {
      startDate: now.minus({ days: 30 }),
      endDate: now.endOf("day"),
    }
  );
};
